import(/* webpackMode: "eager", webpackExports: ["RootLayout"] */ "/var/www/it/cris-aguilar/www/src/components/RootLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/var/www/it/cris-aguilar/www/src/context/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/it/cris-aguilar/www/src/styles/tailwind.css");
